'use es6';

export function ensureFn(fn, fallback = () => {}) {
  return typeof fn === 'function' ? fn : fallback;
}
export function ensurePromise(thing) {
  if (thing instanceof Promise) {
    return thing;
  }

  return Promise.resolve(thing);
}
export function isArray(thing) {
  return Object.prototype.toString.call(thing) === '[object Array]';
}
export function filterObject(obj, predicate = ([, v]) => Boolean(v)) {
  return Object.entries(obj).filter(predicate).reduce((acc, [k, v]) => Object.assign({}, acc, {
    [k]: v
  }), {});
}
export function pick(source = {}, list = []) {
  return Object.assign({}, ...list.map(key => ({
    [key]: source[key]
  })));
}
export function once(func) {
  let result;
  let n = 2;
  return function (...args) {
    if (--n > 0) {
      result = func.apply(this, args);
    }

    if (n <= 1) {
      func = undefined;
    }

    return result;
  };
}
export function defer(func, args) {
  return setTimeout(() => {
    func.apply(undefined, args);
  }, 1);
}
export function merge(target, source) {
  const isObject = obj => typeof obj === 'object' && obj;

  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  Object.keys(source).forEach(key => {
    const targetValue = target[key];
    const sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = merge(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });
  return target;
} // Note: params can both be an object or a string
// @see https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/URLSearchParams#parameters

export function createQueryString(params = '') {
  const searchParams = new URLSearchParams(params);
  return [...searchParams.values()].length ? `?${searchParams.toString()}` : '';
} // Note: params can both be an object or a string
// @see https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/URLSearchParams#parameters

export function createQueryObject(params = '') {
  return Object.fromEntries(new URLSearchParams(params));
}
export const getNavigatorLanguage = (defaultLanguage = 'en-us') => {
  if (typeof navigator === 'object') {
    const preferredLanguage = navigator.languages ? navigator.languages[0] : navigator.language;

    if (preferredLanguage) {
      return preferredLanguage;
    }
  }

  return defaultLanguage;
};